import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";

function MayaKitaClubFlyerPhoto({
  navigation,
  primaryDetails,
  setPrimaryDetails,
}) {
  const [isUploading, setIsUploading] = useState(false);
  const [isError, setIsError] = useState({});

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        flyer_distribution_photo_temp_path: uploadResult.temp_path
      }));
      if (isError.flyer_distribution_photo) {
        setIsError(prev => ({ ...prev, flyer_distribution_photo: false }));
      }
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!primaryDetails.flyer_distribution_photo_temp_path) {
      errors.flyer_distribution_photo = true;
    }
    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateForm()) {
      navigation.next();
    } else {
      toast.error("Please upload the MAYA Kita Club flyer photo.");
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">MAYA KITA CLUB FLYER PHOTO</h4>
              <p className="form-desc">Upload MAYA Kita Club flyer photo</p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* File Upload */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Upload MAYA Kita Club flyer photo <span className="form-required">*</span>
                      {primaryDetails.flyer_distribution_photo_temp_path && !isUploading && (
                        <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={handlePhotoUpload}
                      isInvalid={isError.flyer_distribution_photo}
                      disabled={isUploading}
                    />
                    {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                    {isError.flyer_distribution_photo && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                        Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MayaKitaClubFlyerPhoto;
